export class DocumentoTemplate {
    documentoTemplateId: number = 0;
    documentoTipo: number = 0;
    html: string = ''
    saguiClienteId: number = 0
    descricao: string = '';
}